import { Grid, styled } from "@mui/material";
import { CardFinalMessage } from "styles/general_styles";

export const GridItems = styled(Grid)`
	&.one-row {
		transform: translateY(12%);
	}
`;

export const CustomCardFinalMessage = styled(CardFinalMessage)`
	font-size: clamp(1px, 2.8dvw, 1em) !important;
`;
